import { render, staticRenderFns } from "./ticketDetail.vue?vue&type=template&id=6da6f2e1&scoped=true"
import script from "./ticketDetail.vue?vue&type=script&lang=js"
export * from "./ticketDetail.vue?vue&type=script&lang=js"
import style0 from "./ticketDetail.vue?vue&type=style&index=0&id=6da6f2e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da6f2e1",
  null
  
)

export default component.exports